import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Accordion, Flex, UnstyledButton, Title, Text, Drawer, Divider, Tooltip, Group, Progress, Box } from '@mantine/core';
import { Button, AutomatedAuditLoader, Select, Modal, Checkbox, TextInput } from '@common/components';
import {
  AutomatedSettingsMobile,
  IssuesByPriority,
  SemiCircleProgress,
  StickyBar,
  Table,
} from 'src/components';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import {
  fetchLatestDashboard,
  fetchLatestReportByGroup,
  fetchLatestReportRetry,
  fetchReportSettings,
  runAutomatedAudit,
  setDefault,
  fetchAuditLenght,
  IReportStatus,
  fetchSpecificReport,
  updateReportSettings,
  fetchSpecificDashboard,
  
} from 'src/store/automatedReports';
import { ReactComponent as Clock } from 'src/assets/svg/clock-rounded-arrow.svg';
import { ReactComponent as EmptyTable } from 'src/assets/svg/empty-table.svg';
import { PATHS } from 'src/constants';
import { defaultFilters } from 'src/constants/automatedFilters';
import { useDisclosure, useDocumentTitle, useMediaQuery } from '@mantine/hooks';
import { Lock } from '@geist-ui/icons';
import { createSiteMap, fetchSiteList, fetchSiteMap, FirePutsiteUUID, stopAudit } from 'src/store';
import { getLocalizedDateTime } from '@common/helpers/getCurrentDateAndTime';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { parseDateTimeToUTC } from 'src/helpers/parseDateTimeToUTC';
import i18n from '@common/i18n/config';
import { numberLocalization } from 'src/helpers/numberLocalization';
import { handleDownloadCsvFile, handleDownloadExcelFile } from 'src/helpers/downloadFiles';
import { useAlert } from '@common/hooks';
import NavigationsWebsitesOrganization from 'src/components/NavigationsWebsitesOrganization/page';
import { apiInstance } from 'src/services';
import AddSiteFormIssuePage from 'src/components/forms/AddSiteForm/issuePageForm';


type AlertVariant = 'warning' | 'error' | 'success';


const AutomatedAuditPage = (): JSX.Element => {
  const isLargeDevice = useMediaQuery('(max-width: 1199px)');
  const isMobile = useMediaQuery('(max-width: 767px)');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation('automatedReports');
  const [s] = useTranslation('sitemap');
  const [showSettings, setShowSettings] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [pageNumber, setPageNumber] = useState(Number(searchParams.get('pageNumber')) || 1);
  const { tenantId, organizationsId , isEmailNotificationsEnabled , company_id , websiteCount  } = useAppSelector((state) => state.user.data, shallowEqual);
  const { copiedLinkfilterByPage } = useAppSelector((state) => state.user, shallowEqual);
  
  const [searchQuery, setSearchQuery] = useState<{ [key: string]: string | null }>(
    searchParams.toString().length
      ? Object.assign({}, defaultFilters, Object.fromEntries(new URLSearchParams(location.search)))
      : defaultFilters,
  );
  const organization_Id =  organizationsId ;
  const { id } = useParams();

  const { mapData,reportId } = useAppSelector((state) => state.automatedReports, shallowEqual); 
  const { latestDashboard , specificDashboard  } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { reportSettings } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { latestReportGrouped } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { issuesLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { isGrouping } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { status } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { statusLoading  } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { dashboardLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { settingsLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { loading , error } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { siteError } = useAppSelector((state) => state.siteList, shallowEqual);
  const { isAuditStopped } = useAppSelector((state) => state.stopAudit, shallowEqual);
  const { subscriptionScannedPages } = useAppSelector((state) => state.payment.data);
  const { pageScansPerMonth } = useAppSelector((state) => state.payment.data.metadata);
  const canRunAudit = !(Number(subscriptionScannedPages) >= Number(pageScansPerMonth));
  const [hasRoleToAudit, setHasRoleToAudit] = useState(true);
  const [localizedDate, setLocalizedDate] = useState('');
  const { auditEngines } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const [isLoadingStop, setIsLoadingStop] = useState(false);
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] = useDisclosure(false);
  const [ selectExportToType , setSelectExportToType ] = useState('csv')
  const paginationCurrent = useRef(0);
  const siteUUID = searchParams.get('siteUUID')
  const [opened, { open, close }] = useDisclosure(false);
  const {  loading:loadingSiteMap, data:siteMapData , createLoading } = useAppSelector((state) => state.siteMap, shallowEqual);
  const { specificIssuesLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);

  const siteLists  = useAppSelector((state) => state.siteList.data, shallowEqual);
  const [addSite, setAddSite] = useState(false);
  const [ currentSiteSiteMap , setCurrentSiteSiteMap] = useState<any>([]);
  const { showAlert } = useAlert();
  useDocumentTitle(t('automatedAuditPageTitle'));
  const [ OldAudit , setOldAudit ] = useState<any>();
  const [ dashboardData , setDashboardData ] = useState<any>(latestDashboard);
  const [ dataLoaded , setDataLoaded ] = useState<string | null>(null)
 
 useEffect(() => {
  if(!siteUUID){
    return;
  }
  dispatch(FirePutsiteUUID(siteUUID));  

 }, [siteUUID])

 const {data} = useAppSelector((state) => state.user);

  useEffect(() => {    

    if (id) {

      if ( dataLoaded == id ) return;

      dispatch(fetchReportSettings(id));  
      dispatch(fetchLatestReportRetry({ "id":siteUUID }));
      // dispatch(fetchAuditLenght({id}));
      setDataLoaded(id); 
    }
    return () => {
      dispatch(setDefault());
    };
  }, [id]);

  useEffect( ( ) => {

    if ( !OldAudit && latestDashboard ) {
      setDashboardData(latestDashboard);
      return
    }
    setDashboardData(specificDashboard);

  } , [latestDashboard , specificDashboard, id,data])



  useEffect(() => { 
    if ( opened  && !loadingSiteMap ) {
      dispatch(fetchSiteMap({siteUUID ,tenantId: tenantId, siteId: id }));
    }
  }, [opened]);
  useEffect( () => {
    if ( !siteUUID ) return
    if ( siteMapData[siteUUID]  ) {  
      // const transformedObject = siteMapData[siteUUID]?.reduce((acc: any, currentItem: any) => {
      //   const [key, value] = Object.entries(currentItem)[0];
      //   acc[key] = value;
      //   return acc;
      // }, {});
      // const sitemap = transformedObject
      setCurrentSiteSiteMap(siteMapData[siteUUID]?.length ?? 0)
    }
    
  }, [siteMapData])
   


  useEffect(() => {
    if (latestDashboard?.date && latestDashboard?.time) {
      try {
        const utcDate = parseDateTimeToUTC(latestDashboard.date, latestDashboard.time);
        setLocalizedDate(getLocalizedDateTime(utcDate));
      } catch {
        setLocalizedDate(latestDashboard?.date);
      }
    }
    
    // if(id){
    //   dispatch(fetchAuditLenght({id}));
    // }
    
  }, [latestDashboard,id]);


  const getLatestReport = (): void => {
    if (tenantId) {
      const filteredQuery = Object.keys(searchQuery).reduce<Record<string, string>>((prev, current) => {
        if (searchQuery[current] && searchQuery[current] !== 'all' && searchQuery[current] !== 'true')
          prev[current] = searchQuery[current] as string;
        return prev;
      }, {});

      if (Object.keys(filteredQuery).length) {
        filteredQuery.byGroup
          ? dispatch(fetchLatestReportByGroup({ id, params: { ...filteredQuery, pageNumber: pageNumber } }))
          : dispatch(fetchLatestReportRetry({ "id":siteUUID, params: { ...filteredQuery, pageNumber: pageNumber } }));
      } else {
        dispatch(fetchLatestReportRetry({ 'id':siteUUID, params: { ...filteredQuery, pageNumber: pageNumber } }));
      }

      setSearchParams({ ...filteredQuery, pageNumber: `${pageNumber}` }, { replace: true });
    }
  };

  // useEffect(() => {
  //   // getLatestReport();
  // }, [searchQuery, pageNumber, tenantId]);

  useEffect(() => {
    const setDateValues = (): void => {
      if (latestDashboard?.date && latestDashboard?.time) {
        try {
          const utcDate = parseDateTimeToUTC(latestDashboard.date, latestDashboard.time);
          setLocalizedDate(getLocalizedDateTime(utcDate));
        } catch {
          setLocalizedDate(latestDashboard?.date);
        }
      }
    };

    i18n.on('languageChanged', setDateValues);
    i18n.on('languageChanged', getLatestReport);

    return () => {
      i18n.off('languageChanged', setDateValues);
      i18n.off('languageChanged', getLatestReport);
    };
  }, [latestDashboard]);

  useEffect(() => {
    if (paginationCurrent.current && !issuesLoading) {
      setTimeout(() => {
        const element = document.getElementById('issues-table') as HTMLTableElement;
        if (element) {
          const firstBodyRow = element.rows[1];
          const firstCell = firstBodyRow.cells[0];
          firstCell.focus();
        }
      }, 200);
    }
  }, [issuesLoading]);


  // const changePage = (value: number): void => {
  //   setPageNumber(value);
  //   paginationCurrent.current = value;
  // };


  const handleStopAudit = (): void => {
    try {
      dispatch(stopAudit({ siteUUID }));
    } catch (error) {
      console.error(error);
    }
  };

 
  const auditRuningStatusMessage = (status : IReportStatus) => {

    if ( status.status === '100%') {
      return t('AuditCompleted')
    }
    // Check if the instance status is pending
    if (status.instance_status === 'pending') {
      return t('PreparingAudit')
    }
  
    // Check if there are no reports or pages, but a page exists in auditStatus
    if (status.reportsCount === 0 && status.pagesCount === 0  && status?.auditStatus?.currentPage != "" ) {
      return t('PreparingAudit')
    }
  
    // When both reportsCount and pagesCount are available
    if (status.reportsCount > 0 && status.pagesCount > 0) {
      return  t('inProgressStatus', { pageCount: status?.reportsCount , totalPage: status?.pagesCount })
    }

    // Default message if none of the conditions are met
    return 'Audit status not available';
  };


  async function handleDownloadCsvFilesFrom(e:any) {
    // if ( !reportId ) {
    //   showAlert({
    //     id: 'no-report-id',
    //     title: 'No report ID',
    //     message: 'Somthing went wrong!!',
    //     variant: 'error',
    //     isAccessible:true
    //   });
    //   return
    // }
    setSelectExportToType(e)
    if (e === 'csv') {
      showAlert({
        id: 'start-download',
        title: 'Start Downloading',
        message: 'Your File will be downloaded automatically',
        variant: 'success',
        isAccessible:true
      });
      const { error } = await handleDownloadCsvFile(String(reportId) , id)
      if (error != null) {
        showAlert({
          id: error.message,
          title: 'Error downloading',
          message: 'Something went wrong downloading',
          variant: 'error',
          isAccessible:true
        });
      }
      return
    }

    if (e === 'excel' ) {
      showAlert({
        id: 'start-download',
        title: 'Start Downloading',
        message: 'Your File will be downloaded automatically',
        variant: 'success',
      });
      const { error } = await handleDownloadExcelFile(String(reportId) , id )
      if (error != null) {
        showAlert({
          id: error.message,
          title: 'Error downloading',
          message: 'Something went wrong downloading',
          variant: 'error',
          isAccessible:true
        });
      }
      return
    }
  }

  

  const [ enabeEmailNotification , setEnabeEmailNotification ] = useState(isEmailNotificationsEnabled)
  const speedOption = [
    {
      label: t('speeds.normalLabel'),
      value:  t('speeds.normal'),
    },
    {
      label: t('speeds.HighLabel'),
      value:  t('speeds.High'),
    },
  ]
  function AlertMessage(  ) {
    showAlert({
      id: 'messagess',
      title : 'sss',
      message : 'www',
      variant : 'error',
      isAccessible: true,
    });
  }
  async function handleSettinAndRunAudit() {
    const data = {
      engine_id : reportSettings?.engine_id ,
      frequency : reportSettings?.frequency ?? "none",
      auditSpeed : reportSettings?.auditSpeed ?? 'normal' ,
      notifications : enabeEmailNotification,
      // name: reportSettings?.name ?? reportSettings?.site_name  // double check with backend they are updating the name also
    };
    // dispatch(updateReportSettings({ data , id }));
    if ( siteUUID ) {
      dispatch(runAutomatedAudit({id,organization_Id ,siteUUID , ErrorMessage : () => {


 
        showAlert({
          id: 'erro'+id,
          title : 'Run Audit',
          message : 'Enable to Run Audit Please Try Later.',
          variant : 'error',
          isAccessible: true,
          autoClose : 2000,
        });
      },
      successMessage : () => {
        showAlert({
          id: 'audit-started',
          title: 'Audit Started',
          message:  enabeEmailNotification ? 'You will be notified once audit finished.' : '',
          variant: 'success',
          autoClose : 2000,
        });
      }
    
    }));
      close()
    }
  }
  const loadingSiteList = useAppSelector((state) => state.siteList.loading);
  const { isLoading } = useAppSelector((state) => state.payment);
  const { websites } = useAppSelector((state) => state.payment.data.metadata);
  const canDisplayButton = !( websiteCount  >= Number(websites)) && !isLoading;
  const [c] = useTranslation('common');
  const changeFormState = (): void =>{
    setAddSite(!addSite);
  } 
  const navigateToPayment = (): void => {
    apiInstance.get('payment/portal').then((res) => {
      window.location = res.data.url;
    });
  };

   const [filterByPageVal, setFilterByPageVal] = useState(copiedLinkfilterByPage);

   useEffect(() => {
    setFilterByPageVal(copiedLinkfilterByPage)  
   }, [copiedLinkfilterByPage])
   

  const changeFilterByPageVal = (e: string)=>{
    console.log(e);
    
    if(e){
      setFilterByPageVal(e);
    }

  }

  // useEffect(()=> {
  //   if ( error ) {
  //     showAlert({
  //       id:  'error_' + error.length,
  //       title: 'Something went wrong',
  //       message: error ,
  //       variant: 'error',
  //       isAccessible: true,
  //     });
  //   }
  // } , [error])
  const focusRef = useRef<HTMLDivElement>(null);

  // Use effect to manage focus
  useEffect(() => {
    
    if (statusLoading && focusRef.current) {
      focusRef.current.focus(); // Set focus when isAuditStopped is true
    }
  }, [statusLoading]);

  const selectedSiteData = useAppSelector((state) => state.site.selectedSiteData, shallowEqual);


  const [WebsitesByRoleData, setWebsitesByRoleData] = useState<any>(null)

  function findRoleBySiteID(siteID:any) {
      for (let item of WebsitesByRoleData) {
          if (item.websiteIDs.includes(siteID)) {
              return item.role;
          }
      }
      return null; // return null if no matching site ID is found
  }

  useEffect(() => {
    if(!WebsitesByRoleData || !selectedSiteData ){
      return;
    }
    const role = findRoleBySiteID(selectedSiteData.value.split('|')[0])
    if( ['admin','editor'].includes(role) ){
      setHasRoleToAudit(true);
    }
    else{
      setHasRoleToAudit(false);
    }
  }, [selectedSiteData])
  
  
  return (
    <main className={classNames(styles['main-container'])}>
      <StickyBar className={styles.stickyBar}>
          <>
            {!statusLoading || (!issuesLoading && isAuditStopped) ? (
              <>
                {isMobile ? (
                  <>
                    {dashboardLoading ? (
                      <Flex mih={'45px'} align={'center'}>
                        <AutomatedAuditLoader />
                      </Flex>
                    ) : (
                      <>
                        <Flex w={'100%'} direction={'column'}>
                          <Flex mb={'16px'} justify={'space-between'}>
                            <Flex gap={'10px'} mr={'10px'}>
                              <Tooltip label={`${t('previousAudits')}`}>
                                <div>
                                  <UnstyledButton
                                    aria-label={`${t('previousAudits')}`}
                                    onClick={() => {
                                      navigate(`../${PATHS.AUTOMATED_AUDIT_RUNS}`);
                                    }}>
                                    <Flex gap={'5px'} align={'center'}>
                                      {dashboardData && (
                                        <>
                                          <Flex className={classNames(styles.date)}>
                                            {t('dateOfAudit')} <br></br>
                                            {dashboardData?.date && dashboardData?.time ? localizedDate : t('Error')}
                                          </Flex>
                                          <Clock className={styles.icon} />
                                        </>
                                      )}
                                    </Flex>
                                  </UnstyledButton>
                                  <NavigationsWebsitesOrganization
                                    websitesByRole={(data)=>{setWebsitesByRoleData(data)}}
                                    onSiteSelected={(site) => {
                                      setOldAudit(null);
                                      const parts = site.id.split('|');
                                      const _id =  parts[0];
                                      navigate(`/dashboard/${site.site_id}/automated-audit?siteUUID=${_id}&pageNumber=1`);
                                    }}
                                    onPrevSelected={(audit) => {
                                      setOldAudit(audit);
                                      dispatch(fetchSpecificReport({ id: audit?.siteUUID, runId: audit?.id, tracking_number: audit?.tracking_number }));
                                      dispatch(fetchSpecificDashboard({ id: siteUUID, runId: audit?.id }));
                                    }}
                                  />
                                </div>
                              </Tooltip>
                            </Flex>
                          </Flex>

                          <Button
                            disabled={!canRunAudit || !hasRoleToAudit}
                            loading={loading}
                            onClick={() => {
                              if (siteUUID) {
                                open()
                              }
                            }}>
                            <Flex gap={'5px'}>
                              {!canRunAudit && <Lock size={16} aria-label={`${t('lockedItem')}`} />}
                              {t('runAuditBtn')}
                            </Flex>
                          </Button>
                        </Flex>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    { dashboardLoading  ? (
                      <Flex mih={'45px'} align={'center'}>
                        <AutomatedAuditLoader />
                      </Flex>
                    ) : (
                      <>
                        <Flex w={'100%'} align={'center'} direction={'column'}>
                        <Flex w={'100%'} align={'end'} justify={"space-between"}>
                            <NavigationsWebsitesOrganization
                                websitesByRole={(data)=>{setWebsitesByRoleData(data)}}
                               onSiteSelected={(site) => {
                                if ( !site || site?.site_id == id  ) return
                                setOldAudit(null);
                                const parts = site.id.split('|');
                                const _id =  parts[0];
                                navigate(`/dashboard/${site.site_id}/automated-audit?siteUUID=${_id}&pageNumber=1`);
                              }}
                              onPrevSelected={(audit) => {
                                if (!audit ) return;
                                setOldAudit(audit);
                                dispatch(fetchSpecificReport({ id : siteUUID , runId : audit?.id, tracking_number : audit?.tracking_number }));
                                dispatch(fetchSpecificDashboard({ id : siteUUID , runId : audit?.id }));  
                              }}
                            />
                          <Flex ml={'auto'} gap={'16px'} wrap={'wrap'}>
                            <span>
                              {t('Compliance Standard:')}{' '}
                              <b className={styles['capitalize-text']}>
                                {!dashboardLoading ? (
                                  dashboardData?.standard ?  dashboardData?.standard   :  <span aria-label='No Vially Score'>--</span>
                                ) : (
                                  <AutomatedAuditLoader />
                                )}
                              </b>
                            </span>
                          </Flex>

                          <Flex ml={'32px'} gap={'18px'}>
                            <Tooltip label={ !hasRoleToAudit ? "You don't have right to run an audit" : !canRunAudit ? 'You reach the limit' :  `${t('runAuditBtn')}`}>
                              <div>
                                <Button
                                  disabled={!canRunAudit || !hasRoleToAudit}
                                  loading={loading}
                                  onClick={() => {
                                    open()
                                  }}>
                                  <Flex gap={'5px'}>
                                    { !canRunAudit  && <Lock size={16} aria-label={`${t('lockedItem')}`} />}
                                    {t('runAuditBtn')} 
                                  </Flex>
                                </Button>
                              </div>
                            </Tooltip>
                            {!addSite && (
                              <>
                                <Button
                                  className={classNames({ [styles['link-btn']]: !loading && !canDisplayButton })}
                                  id={'addSiteButton'}
                                  loading={loading}
                                  ariaLabel={!loading && !canDisplayButton ? `${c('myPlan')} ${c('opensInNewTabLink')}` : 'Add site'}
                                  // disabled={!hasPermission}
                                  onClick={() => (!loading && !canDisplayButton ? navigateToPayment() : setAddSite(true))}>
                                  {
                                    !loading && !canDisplayButton ?
                                      <Tooltip label="The Maximum Site Limit Has Been Reached">
                                        <Flex gap={'5px'}>
                                           <Lock size={16} aria-label="locked item" />
                                          Add Site
                                        </Flex>
                                      </Tooltip> :
                                      'Add Site'
                                  }
                                </Button>
                              </>
                            )}
                          </Flex>
                             
                        </Flex>
                        {addSite && (
                          <AddSiteFormIssuePage
                          style={{alignItems : "end"}}
                          changeFormState={changeFormState}
                          listItems={siteLists} 
                          canDisplayButton={canDisplayButton}
                          companyId={company_id} isAccountPage={true} />
                        )}
                      </Flex>
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <Flex w={'100%'} align={'center'} justify={'space-between'}>

                <Flex ref={focusRef} tabIndex={-1} direction="column" align="center" gap="16px"  >
                  <div>
                    <AutomatedAuditLoader /> <b> { status && auditRuningStatusMessage(status)}</b>
                  </div>
                  <ProgressBar reportsCount={status?.reportsCount} pagesCount={status?.pagesCount} />

                  <div role="alert" aria-live="assertive" className={styles['visually-hidden']}>
                    <span> { status && auditRuningStatusMessage(status) }</span>
                  </div>
                </Flex>

                <Flex direction={"column"}> 
                <Flex align={"end"} justify={"end"} gap={"md"}>
                  <NavigationsWebsitesOrganization
                      websitesByRole={(data)=>{setWebsitesByRoleData(data)}}
                      onSiteSelected={(site) => {
                        if ( !site || site?.site_id == id  ) return
                        setOldAudit(null);
                        const parts = site.id.split('|');
                        const _id =  parts[0];
                        navigate(`/dashboard/${site.site_id}/automated-audit?siteUUID=${_id}&pageNumber=1`);
                      }}
                      onPrevSelected={(audit) => {
                        if (!audit ) return;
                        setOldAudit(audit);
                        dispatch(fetchSpecificReport({ id : audit?.siteUUID , runId : audit?.id, tracking_number : audit?.tracking_number }));
                        dispatch(fetchSpecificDashboard({ id : siteUUID , runId : audit?.id }));
                      }}
                  />
                  <Button loading={isLoadingStop} className={styles.stopBtn} onClick={handleStopAudit} ariaLabel='Stop audit'>
                      Stop
                  </Button>
                  {!addSite && (
                      <>
                        <Button
                          className={classNames({ [styles['link-btn']]: !loading && !canDisplayButton })}
                          id={'addSiteButton'}
                          loading={loading}
                          ariaLabel={!loading && !canDisplayButton ? `${c('myPlan')} ${c('opensInNewTabLink')}` : 'Add Site'}
                          // disabled={!hasPermission}
                          onClick={() => (!canDisplayButton ? navigateToPayment() : setAddSite(true))}>
                          {
                            !loading && !canDisplayButton ?
                              <Tooltip label="The Maximum Site Limit Has Been Reached">
                                <Flex gap={'5px'}>
                                  {(!loading && !canDisplayButton) && <Lock size={16} aria-label="locked item" />}
                                  Add Site
                                </Flex>
                              </Tooltip> :
                              'Add Site'
                          }
                        </Button>
                      </>
                    )}
                </Flex>
                {addSite && (
                    <AddSiteFormIssuePage
                      style={{ alignItems: "end" }}
                      changeFormState={changeFormState}
                      listItems={siteLists}
                      canDisplayButton={canDisplayButton}
                      companyId={company_id} isAccountPage={true} />
                  )}

                </Flex>
              </Flex>
            )}
          </>
        {/* )} */}
      </StickyBar>
      <div className={classNames(styles['content-wrapper'])}>
        <Flex direction={isLargeDevice ? 'column' : 'row'} gap={'16px'} mb={'24px'} align={"center"}>
          <div className={styles.cardslick}>
            <SemiCircleProgress
              diameter={isMobile ? 72 : 200}
              strokeWidth={isMobile ? 7 : 20}
              showPercentValue
              percentage={dashboardData?.complianceScore ? Math.ceil(dashboardData.complianceScore) : 0}
            />
            <Text weight={isMobile ? 400 : 700} py={isMobile ? 8 : 24}>
              <strong> {t('ViallyScore')} </strong>
            </Text>
            <Link color='#5b5eff' to={"/faq?tab=vially-score"} >What is Vially Score?</Link>
          </div>
          {/* 2 section */}
          <Flex style={{
            width: '100%',
            flex: 1,
          }} direction={"column"} gap={'xl'} >
            <Flex
              gap={"md"}
              direction={isMobile ? 'column' : 'row'}
              justify={isMobile ? '' : 'space-between'}
              style={{
                width: '100%',
              }}>
              <Flex
                className={styles['graphic-items-wrapper']}
                justify={isLargeDevice ? 'space-between' : ''}
                gap={'35px'}
                mr={isLargeDevice ? '' : 'auto'}>

              </Flex>
              <Flex gap={"md"} className={styles['page-items-wrapper']}>
              <UnstyledButton
                className={styles['graphic-item']}
                h={isLargeDevice ? 'auto' : '100%'}
                aria-label={ dashboardData?.numberOfIssues  ? `${numberLocalization(dashboardData?.numberOfIssues)} Total Issues , Total Issues button` : 'Zero Total Issues, Total Issues button'}
                >
                {loading ? (
                  <AutomatedAuditLoader />
                ) : (
                  <Flex className={classNames(styles['issue-text'])} gap={6}>
                    {numberLocalization(dashboardData?.numberOfIssues) ?? <span aria-hidden={true} aria-label='Total Issues'>--</span>}
                  </Flex>
                )}
                <span>Total Issues</span>
              </UnstyledButton>
              <Divider className={styles['divider']} orientation={!isMobile ? 'vertical' : 'horizontal'} color={'gray'} my={!isMobile ? 'none' : 'xl'}  aria-hidden="true" role="presentation"></Divider>
              <UnstyledButton
                className={styles['graphic-item']}
                h={isLargeDevice ? 'auto' : '100%'}
                aria-label={ dashboardData?.closedIssues ? `${numberLocalization(dashboardData?.closedIssues)} Closed Issues , Closed Issues button` : 'Zero Closed Issues,  Closed Issues button'}
                >
                {loading ? (
                  <AutomatedAuditLoader />
                ) : (
                  <Flex className={classNames(styles['issue-text'])} gap={6}>
                   {numberLocalization(dashboardData?.closedIssues) ?? <span aria-hidden={true} aria-label='Closed Issues'>--</span>}
                  </Flex>
                )}
                <span aria-hidden={true}>Closed Issues</span>
              </UnstyledButton>
              <Divider className={styles['divider']} orientation={!isMobile ? 'vertical' : 'horizontal'} color={'gray'} my={!isMobile ? 'none' : 'xl'}  aria-hidden="true"  role="presentation"></Divider>



              <UnstyledButton
                className={styles['graphic-item']}
                h={isLargeDevice ? 'auto' : '100%'}
                aria-label={ dashboardData?.openIssues  ? ` ${numberLocalization(dashboardData?.openIssues)} Open Issues , Open Issues button` : 'Zero Open Issues,  Open Issues button'}
                >
                {loading ? (
                  <AutomatedAuditLoader />
                ) : (
                  <Flex className={classNames(styles['issue-text'])} gap={6}>
                    {numberLocalization(dashboardData?.openIssues) ?? <span aria-hidden={true} aria-label='Open Issues'>--</span>}
                  </Flex>
                )}
                <span aria-hidden={true} >Open Issues</span>
              </UnstyledButton>
              <Divider className={styles['divider']} orientation={!isMobile ? 'vertical' : 'horizontal'} color={'gray'} my={!isMobile ? 'none' : 'xl'}  aria-hidden="true" role="presentation"></Divider>
                <UnstyledButton
                  aria-label={ dashboardData?.newsIssues ? `${numberLocalization(dashboardData?.newsIssues) } new Issues, new Issues button` : 'Zero new Issues, new Issues button' }
                  className={styles['graphic-item']}
                  h={isLargeDevice ? 'auto' : '100%'}
                >
                  {loading ? (
                    <AutomatedAuditLoader />
                  ) : (
                    <Flex className={classNames(styles['number-of-issues'])} gap={6}>
                       {numberLocalization(dashboardData?.newsIssues) ?? <span aria-hidden={true} aria-label='Zero new Issues'>--</span> }
                    </Flex>
                  )}
                  <span aria-hidden={true} >{t('newIssues')}</span>
                </UnstyledButton>
                <Divider className={styles['divider']} orientation={'vertical'} color={'gray'} my={'none'}  aria-hidden="true" role="presentation"></Divider>
                <UnstyledButton
                  className={styles['graphic-item']}
                  h={isLargeDevice ? 'auto' : '100%'}
                  aria-label={ dashboardData?.pagesScanned ? `${numberLocalization(Math.ceil(dashboardData?.pagesScanned))} total Pages Scanned, total Pages Scanned button` : 'Zero total Pages Scanned, total Pages Scanned button' }
                >
                  {loading ? (
                      <AutomatedAuditLoader />
                    ) : dashboardData?.pagesScanned ? (
                      <Flex className={classNames(styles['issue-text'])} gap={6}>
                      { numberLocalization(Math.ceil(dashboardData?.pagesScanned)) }
                      </Flex>
                    ) : (
                      <span aria-hidden={true} aria-label='Zero total Pages Scanned'>--</span>
                    )}
                 <span aria-hidden={true} >{t('totalPagesScanned')}</span>
                </UnstyledButton>
              </Flex>
            </Flex>
            <IssuesByPriority
              data={dashboardData}
              loading={issuesLoading}
              setSearchQuery={setSearchQuery}
              searchQuery={searchQuery}
              css={
                { width: '100%' }
              }
            />
          </Flex>
        </Flex>
        {isGrouping ? (
          <>
            {latestReportGrouped.length ? (
              latestReportGrouped.map((report) => (
                <Accordion
                  className={classNames(styles['accordion-wrapper'])}
                  key={report.groupValue}
                  defaultValue={[]}
                  multiple>
                  <Accordion.Item value="customization">
                    <Accordion.Control>
                      {report.issues.length} {t('issuesBy')} {report.groupValue}
                    </Accordion.Control>
                    <Accordion.Panel>
                      <div className={styles['table-wrapper']}>
                        <Table report={report.issues}></Table>
                      </div>
                    </Accordion.Panel>
                  </Accordion.Item>
                </Accordion>
              ))
            ) : (
              <div>
                <Title size={22} order={2}>
                  {t('noIssuesYet')}
                </Title>
                <Flex
                  mih={'375px'}
                  bg={'#ffffff'}
                  direction={'column'}
                  align={'center'}
                  justify={'center'}
                  gap={'24px'}>
                  <EmptyTable />
                  <Text>{t('noDataYet')}</Text>
                </Flex>
              </div>
            )}
          </>
        ) : (
          <>
             { (!issuesLoading && !specificIssuesLoading && mapData && mapData.length) ? (
              <div className={`${styles['table-wrapper']} tableOverflow `}
              style={{
                overflowX: isMobile ? 'hidden' : 'auto',
                // height: isMobile ? 'auto' : '31.25rem',
              }}
              >
                
                  <Flex gap={"md"} justify={"end"} p={"xl"} align={"center"} >
                    {/* <TextInput
                      label={'Page Filter'}
                      withAsterisk={true}
                      placeholder={'Enter Url'}
                      value={filterByPageVal}
                      onChange={(e)=>changeFilterByPageVal(e.target.value)}
                      className={styles.inputwidh}
                    /> */}
                    <Flex justify={"end"}>
                      {/* <Tooltip label={`Export ${id} Report Result in CSV Format`}> */}
                        <Flex gap={"md"} align={"center"} justify={"end"}>
                          {/* <label htmlFor="exportto">Export</label> */}
                          {/* <Select
                            className={styles.padding}
                            variant="secondary"
                            withIcon
                            value={selectExportToType}
                            data={[
                              {
                                label: 'CSV',
                                value: 'csv',
                              },
                              // {
                              //   label: 'Excel',
                              //   value: 'excel',
                              // },
                            ]}
                            onChange={(e) => }
                            aria-label="Export website report in csv format, open the dropdown field to select from the export type. Press the spacebar to open the dropdown on your keyboard and use the arrow keys to navigate, download will start automatically"
                            width={'200px'}
                            {...{ id: 'exportto', p: 'md' ,   }}
                          /> */}
                          <Button 
                            onClick = {()=>handleDownloadCsvFilesFrom('csv')} 
                            aria-label="Download website report in csv format"                             
                            > 
                            Download CSV
                          </Button>
                          {/* <Button 
                            onClick = {()=>handleDownloadCsvFilesFrom('excel')} 
                            aria-label="Download website report in excel format"                             
                            >
                            Download Excel
                          </Button> */}
                        </Flex>
                      {/* </Tooltip> */}
                    </Flex>
                </Flex> 
                <Table report={mapData}></Table>
              </div>
            ) : (
              <div>
                <Title size={22} order={2}>
                  {t('noIssuesYet')}
                </Title>
                <Flex
                  mih={'375px'}
                  bg={'#ffffff'}
                  direction={'column'}
                  align={'center'}
                  justify={'center'}
                  gap={'24px'}>
                  { ( issuesLoading || specificIssuesLoading) ? (
                    <>
                      <AutomatedAuditLoader />
                      <Text>{t('lookingForIssues')}</Text>
                    </>
                  ) : (
                    <>
                      <EmptyTable />
                      <Text>{t('noDataYet')}</Text>
                    </>
                  )}
                </Flex>
              </div>
            )}
          </>
        )}
        {/* {!!latestReport?.length && !issuesLoading && (
          <Pagination
            className={styles['automated-pagination']}
            value={pageNumber}
            onChange={changePage}
            total={pageTotal}
            previousAriaLabel={`${t('previousAriaLabel')}`}
            nextAriaLabel={`${t('nextAriaLabel')}`}
          />
        )} */}
      </div>

      {showSettings && <div className={classNames(styles['settings-backdrop'])}></div>}

      <Drawer
        zIndex={1001}
        size={'100%'}
        className={styles.innerWrapperMobile}
        opened={drawerOpened}
        onClose={closeDrawer}
        withCloseButton={false}>
        <AutomatedSettingsMobile
          reportSettings={reportSettings}
          setShowSettings={closeDrawer}
          showSettings={drawerOpened}
          auditEngines={auditEngines}
        />
      </Drawer>

      <Modal opened={opened} close={close} zIndex={1000} withCloseButton={false} size={616} padding={0}>
        <Flex align={'center'} direction={"column"} p={28}>
          <Title order={2}>Running Audit</Title>
          <Text align={'center'}>Are you sure you want to start an audit for</Text>
          <strong>{id}</strong>
        </Flex>
                <Group w={"100%"} align={'center'} position={'left'} p={28}>
          {loadingSiteMap ? (
            <>
              <AutomatedAuditLoader />
              <p>{ s('sitemapIsCreatingBtn')}</p>
            </>

          ) : !currentSiteSiteMap || currentSiteSiteMap == 0 ? ( 
              <Flex style={{ width : '100%'}} p={"0"} justify={"space-between"} align={"center"}>
                <Text>Number of pages</Text>
                <Button
                    disabled={createLoading}
                    loading={ (loading || createLoading) }
                    onClick={() => {
                      dispatch(createSiteMap({ siteUUID}));
                    }}>
                    <Flex gap={'5px'}>
                      {createLoading && <Lock size={16} aria-label={`${s('lockedItem')}`} />}
                      {createLoading ? s('sitemapIsCreatingBtn')  : 'Create Sitemap' }
                    </Flex>
                  </Button>
            </Flex>
          ) : (
                <Flex style={{ width: '100%' }} p={"0"} justify={"space-between"} align={"center"} >
                  <Text>Number of Pages: </Text>
                  <Flex gap={"sm"} align={"center"}>
                    <strong className={styles.nbSiteMapPages}>{
                       currentSiteSiteMap ?? 0
                    }</strong>
                    <NavLink style={{ textDecoration: 'none', color: 'black' }} to={`/account/account-details/sitemap-${id}/${siteUUID}?company=${selectedSiteData?.company_id}&sitedId=${id}#MainAccordion-panel-${siteUUID}`}>
                      <Button color='gray-light' >
                        <Text>Edit Sitemap</Text>
                      </Button>
                    </NavLink>
                  </Flex>
                </Flex>
          )} 
          
        </Group>

        <Flex  pb="md" justify={"start"} align={"start"} direction={"column"} px={28} gap={"md"}>
          <Checkbox
            label="Notify me once audit is complete"
            checked={Boolean(enabeEmailNotification)}
            onChecked={(e) =>  {  setEnabeEmailNotification(e.target.checked)  }}
          />
          {/* <Flex pb={"md"} justify={"space-between"} align={"center"} gap={"md"} w={"100%"}>
            <Text>Audit Speed:</Text>
            <Select
              className={styles.padding}
              variant="secondary"
              withIcon 
              value={ auditSpeed }
              data={speedOption}
              onChange={handleAuditSpeed}
            />
          </Flex> */}
        </Flex>
        <div className={classNames(styles['btn-group'])}>
          <UnstyledButton onClick={close} className={classNames(styles['action-btn'])}>
            Cancel
          </UnstyledButton>
          <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
          <UnstyledButton
            onClick={() => {  handleSettinAndRunAudit()}}
            aria-label='Run Audit'   className={classNames(styles['action-btn'] , styles.btndelete)}>
            Run Audit
          </UnstyledButton>
        </div>
      </Modal>
    </main>
  );
};

export default AutomatedAuditPage;



interface ProgressBarProps {
  reportsCount: number|undefined; // Number of pages scanned
  pagesCount: number|undefined;   // Total pages to scan
}

const ProgressBar: React.FC<ProgressBarProps> = ({ reportsCount, pagesCount }) => {
  if(!reportsCount || !pagesCount ){
    return <></>;
  }
  // Calculate progress percentage
  const progress = pagesCount > 0 ? (reportsCount / pagesCount) * 100 : 0;
  const [t] = useTranslation('automatedReports');

  return (
    <Box w={'160px'} aria-label={t('inProgressStatus', { pageCount: reportsCount , totalPage: pagesCount })}>
      {/* <Text size="sm" weight={500} align="center" mb="xs">
        {`Scanned: ${reportsCount} / ${pagesCount} Pages`}
      </Text> */}
      <Progress  value={progress} color="blue" size="lg" radius="md" />
      {/* <Text size="sm" align="center" mt="xs">
        {`${progress.toFixed(2)}%`}
      </Text> */}
    </Box>
  );
};